import React from "react";
import "../styles/Welcome.css";
import { CheckCircle } from "lucide-react";

const services = [
  {
    list: [
      "Strategic Consulting & Advisory",
      "Startup Development & Innovation Programs",
      "Branding, Marketing & Digital Growth      ",
    ],
  },
];
const Welcome = () => {
  return (
    <section className="Welcome-section">
      <div className="Welcome-container">
        <p className="Welcome-subtitle">ABOUT US</p>
        <h2 className="Welcome-heading">
          <span>Empowering Ideas. </span>{" "}
          <span className="light">Accelerating Africa’s Growth.</span>
        </h2>
        <p className="Welcome-description">
          NexaGrowth Africa is a{" "}
          <strong>Ghana-based management consulting </strong> and 
          <strong> innovation firm dedicated</strong> to helping{" "}
          <strong>startups, businesses,</strong> and
          <strong> institutions</strong> unlock{" "}
          <strong>growth, enhance efficiency,</strong> and{" "}
          <strong>lead with impact.</strong>
        </p>
        <p className="Welcome-description">
          We specialize in{" "}
          <strong>
            strategic consulting, market expansion, entrepreneurship
            development,
          </strong>{" "}
          and <strong>digital transformation</strong> — all tailored to Africa’s
          evolving business landscape. With our unique blend of{" "}
          <strong>data-driven strategy, practical insights,</strong> and{" "}
          <strong>a deep commitment to sustainable development,</strong> we help
          our clients grow from potential to performance.
        </p>
        {services[0].list.map((item, index) => (
          <div className="icon-text" key={index}>
            <CheckCircle size={24} className="content-check-icon" />
            <h4>{item}</h4>
          </div>
        ))}{" "}
      </div>
      <div className="Welcome-image-wrapper">
        <div className="Welcome-image">
          <img src="/Hero.png" alt="Office environment" />
        </div>
      </div>
    </section>
  );
};

export default Welcome;
